import { useState, useEffect } from "react";
import { Alert, Button } from "reactstrap";

//App
import useSnackBarStyles from "./styles";
import { SnackbarProps } from "../../../../types";

const Snackbar: React.FC<SnackbarProps> = ({
  open,
  message,
  severity,
  handleClose,
}) => {
  const snackBarStyles = useSnackBarStyles();
  const [isVisible, setIsVisible] = useState(open);
  const autoHideDuration = 10000;

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    if (open) {
      setIsVisible(true);

      timeoutId = setTimeout(() => {
        handleClose();
        setIsVisible(false);
      }, autoHideDuration);
    }

    return () => {
      clearTimeout(timeoutId);
    };
  }, [open, autoHideDuration, handleClose]);

  const onClose = () => {
    handleClose();
    setIsVisible(false);
  };

  return (
    <div style={snackBarStyles.container}>
      {isVisible && (
        <Alert className={`bg-${severity}`} style={snackBarStyles.alert}>
          {message}
          <Button close onClick={onClose} style={snackBarStyles.closeButton} />
        </Alert>
      )}
    </div>
  );
};

export default Snackbar;
